function buildPrice() {
      var extras = 0;

      if ($('.club-number-inputs').length > 0){
          var numberOfClubs = $('.club-number-inputs:checkbox:checked').length;
        } else {
        var numberOfClubs = 1;
        }
      $( ".extra" ).each(function( index ) {
        var selectedExtra = ($(this).val());

        if (selectedExtra == null || selectedExtra == ""){
          var extraPrice = 0.00;
        } else {
          if ($(this).hasClass( "installFee" )){
            if ($(this).is(":checked")) {
             var extraPrice = $(this).data('price') * numberOfClubs; 
            } else {
            var extraPrice = 0; 
            }
            
          } else {
          var extraPrice = $(this).children('option[value='+selectedExtra+']').data('price');
           
              
            var extraPrice = extraPrice.toString().replace(',', '.').replace(/\s/g, '');  
            
            var extraPrice = parseFloat(extraPrice);
            var extraPrice = extraPrice * numberOfClubs;   
         // console.log(extraPrice.toLocaleString("it-IT", {style:"currency", currency:"EUR"}));
          }
        }

        extras = extras + extraPrice;
      });

      var clubVariantPriceTotal = clubVariantPrice * numberOfClubs;
 
      var clubVariantCompareAtPriceTotal = clubVariantCompareAtPrice * numberOfClubs;
      var customPriceTotal = clubVariantPriceTotal + extras;

      var compareAtPriceTotal = clubVariantCompareAtPriceTotal + extras;
      var compareAtPriceTotalShopify = compareAtPriceTotal * 100;

      var customPriceTotalShopify = customPriceTotal * 100;
      let formattedCustomPriceTotal = Shopify && Shopify.formatMoney(customPriceTotalShopify, `${currency_symbol} {{amount}}`);
      let formattedCustomComparePriceTotal = Shopify && Shopify.formatMoney(compareAtPriceTotalShopify, `${currency_symbol} {{amount}}`);
  
      //let formattedCustomComparePriceTotal = compareAtPriceTotal.toLocaleString("de-DE", {style:"currency", currency:iso_code});
      //let formattedCustomPriceTotal = customPriceTotal.toLocaleString("de-DE", {style:"currency", currency:iso_code, currencyDisplay: "symbol"});

  if ($(".product-price-container .price del").html() == undefined){
        var currentPriceDisplay = $(".product-price-container .price").text();
          $(".product-price-container .price-inner").text(formattedCustomPriceTotal); 
        } else {
          $(".product-price-container .price ins span").text(formattedCustomPriceTotal); 
          $(".product-price-container .price del span").text(formattedCustomComparePriceTotal); 
          
        }
    }

/*
  function buildPrice() {
        //go through all add ons, times them by club number, then add clubVariantPrice

        var numberOfClubs = $('.club-number-inputs:checkbox:checked').length;
        var shaftPrice = $(".shaft").find(':selected').data('shaftprice') * numberOfClubs;
        var gripPrice = $(".grip").find(':selected').data('gripprice') * numberOfClubs;
        var sstPrice = $(".sst").find(':selected').data('sstprice') * numberOfClubs;
        var clubVariantPriceTotal = clubVariantPrice * numberOfClubs;
        var customPriceTotal = clubVariantPriceTotal + shaftPrice + gripPrice + sstPrice;
        let formattedCustomPriceTotal = customPriceTotal.toLocaleString("en-US", {style:"currency", currency:"USD"});
        $(".product-price-container .price").text(formattedCustomPriceTotal);
    }
*/
function changeShaftBrand(initialLoad){
  
  var shaftBrand = $(".shaftBrand").find(':selected').data('brand');
   $("span .shaft-model").unwrap();
  if (initialLoad != "yes"){
    if (productType == "Custom Iron Set" || productType == "Custom Wedge" || productType == "Custom Utility Iron"){
      var materialType = $('.material-radios input[name="radioMaterial"]:checked').val();
      $(".shaft option").not("[data-material="+materialType+"]").not("[data-material='both']").not(".shaft span option").wrap('<span>');
    } 
      var shaftBrandFirstModel = $(".shaft option[data-brand='" + shaftBrand + "']").not(".shaft span option").first().val();
    
   setTimeout(function () {
     $(".shaft").val(shaftBrandFirstModel).change();
   }, 250);
    
  } else {
    var shaftBrandFirstModel = $(".shaft option[data-brand='" + shaftBrand + "']").first();
    var shaftBrandFirstModelImage = shaftBrandFirstModel.data("img");
      $(".shaft-image").attr('src', shaftBrandFirstModelImage);
  }
      
       $(".shaft option").not("option[data-brand='" + shaftBrand + "']").not(".shaft span option").wrap('<span></span>');
       $(".config").slick("setOption", '', '', true);
}


/*
change shaft brand
change shaft model
change flex 
change material

-->Hide brands that dont match material selection (woods will always be graphite and match)
  -->Only needs to run when material selection changes
-->hide models that dont match selected brand, flex, and material
  -->Can run on every change
-->Change shaft to first matching model, triggering image change

Special conditions
-->If free flex, dont filter for flex
-->If 0 matching options, show no option message
*/

async function filterShaftOptions(initialLoad, brandChange, materialChange) {
    $('.shaft, .shaft-grip-image-container').addClass("custom-loading");
    var shaftFlex = $("input[name='flex']:checked").val();
    var shaftBrand = $(".shaftBrand").find(':selected').data('brand');
    var materialType;
    
    if (productType === "Custom Iron Set" || productType === "Custom Wedge" || productType === "Custom Utility Iron") {
        materialType = $('.material-radios input[name="radioMaterial"]:checked').val();
    } else {
        materialType = "graphite";
    }

  

    if (brandChange) {
        var handle = $(".shaftBrand").find(':selected').data('handle');

        try {
            const response = await fetch(window.Shopify.routes.root + 'products/' + handle + '?view=data');
            const product = await response.json();

            var selectElement = $('.shaft');
            selectElement.html("");

            $.each(product.variants, function(index, item) {
                if (productType.includes("Driver") && item.title.includes("Fairway")) {
                    return true;
                }

                var optionElement = $('<option></option>').attr({
                    'data-brand': item.vendor,
                    'data-model': item.title,
                    'data-img': item.image,
                    'data-flex': item.flex,
                    'data-sku': item.sku,
                    'data-material': item.material,
                    'data-shaftdesc': item.characteristics,
                    'class': 'product-variant shaft-model ' + item.vendor,
                    'value': item.id,
                    'data-price': item.price,
                    'data-nolengths': item.no_lengths,
                    'disabled': item.available === "false"
                }).html(item.title + item.price_formatted);
                selectElement.append(optionElement);
            });

            // Your code that depends on the fetched data
            // Add it here directly after the fetch operation

        } catch (error) {
            console.error('Error fetching data:', error);
            // Handle error
        }
    }

    if (materialChange) {
        var selectedBrandMaterial = $(".shaftBrand").find(':selected').data('material');
        if (selectedBrandMaterial === undefined) {
         var selectedBrandMaterial = "steel"; 
        }

        var defaultBrand;
        $(".shaftBrand span option").unwrap();
        if (materialType === "steel") {
            defaultBrand = "NoUpcharge";
         $(".shaftBrand option[data-material='graphite']").not(".shaftBrand option[data-material='both']").not(".shaftBrand span option").wrap('<span></span>');
        } else if (materialType === "graphite") {
            defaultBrand = "Aerotech";
          $(".shaftBrand option").not("[data-material='graphite']").not("[data-material='both']").not(".shaftBrand span option").wrap('<span></span>');
        }
    
        if (selectedBrandMaterial !== materialType && selectedBrandMaterial !== "both") {
            $(".shaftBrand").val(defaultBrand).change();
        }
    }
     
   
      $(".shaft span option").unwrap();


  if (shaftBrand != "FreeFlex"){
       $(".shaft option").not("option[data-brand='" + shaftBrand + "'][data-material='" + materialType + "'][data-flex='" + shaftFlex + "']").not(".shaft span option").wrap('<span></span>');
      var shaftBrandFirstModel = $(".shaft option[data-brand='" + shaftBrand + "'][data-flex='"+shaftFlex+"'][data-material='" + materialType + "']").first().val();
      var flexCount = $(".shaft option[data-brand='"+shaftBrand+"'][data-flex='"+shaftFlex+"'][data-material="+materialType+"]").length;     
    
      if (flexCount === 0){
              $(".shaft option[data-flex='NA']").unwrap();
              $(".shaft").val(12345678910).change();
              var shaftBrandFirstModelObject = $(".shaft option[data-flex='NA']");
            } else {
             $(".shaft").val(shaftBrandFirstModel).change();
             var shaftBrandFirstModelObject = $(".shaft option[data-brand='" + shaftBrand + "'][data-flex='"+shaftFlex+"'][data-material='" + materialType + "']").first();
            }
  } else {
    $(".shaft option").not("option[data-brand='" + shaftBrand + "'][data-material='" + materialType + "']").not(".shaft span option").wrap('<span></span>');
    var shaftBrandFirstModel = $(".shaft option[data-brand='" + shaftBrand + "']").first().val();
    var shaftBrandFirstModelObject = $(".shaft option[data-brand='" + shaftBrand + "'][data-material='" + materialType + "']").first();
    $(".shaft").val(shaftBrandFirstModel).change();
  }
  
      
      var shaftBrandFirstModelImage = shaftBrandFirstModelObject.data("img"); 
      var shaftDesc = shaftBrandFirstModelObject.data("shaftdesc");

            $(".shaft-image").attr('src', shaftBrandFirstModelImage);
            $(".shaftDesc").html(shaftDesc);
            $(".config").slick("setOption", '', '', true);

  if (brandChange === false && materialChange === false){
    //delay slightly to let user know something is changing
    setTimeout(function() {
        $('.shaft, .shaft-grip-image-container').removeClass("custom-loading");
    }, 200);
  } else {
    $('.shaft, .shaft-grip-image-container').removeClass("custom-loading");
  }
           
   
      
}
  


function changeShaftBrandWithFlex(initialLoad){
  var handle = $(".shaftBrand").find(':selected').data('handle');
  fetch(window.Shopify.routes.root + 'products/'+handle+'?view=data&type='+productType)
  .then(response => response.json())
  .then(product => {
    var selectElement = $('.shaft');
    $(".shaft").html("");
    var flexCount = 0;
    var shaftFlex = $("input[name='flex']:checked").val();
  $.each( product.variants, function(index, item) {
  //console.log( item.id );
if (productType.includes("Driver") === true && item.title.includes("Fairway") === true) {
  return true;
}
    
    var optionElement = $('<option></option>').attr({
        'data-brand': item.vendor,
        'data-model': item.title, // Replace 'Model Name' with the actual model name from your data
        'data-img': item.image,
        'data-flex': item.flex,
        'data-material': item.material,
        'data-shaftdesc': item.characteristics,
        'class': 'product-variant shaft-model ' + item.vendor,
        'value': item.id,
        'data-price': item.price
    }).text(item.title + item.price_formatted);
    selectElement.append(optionElement);
   if (item.flex === shaftFlex) {
        flexCount++; // Increment count if flex value is "S"
    }
});

    var shaftBrand = $(".shaftBrand").find(':selected').data('brand');
   $("span .shaft-model").unwrap();
  if (initialLoad != "yes"){
    if (productType == "Custom Iron Set" || productType == "Custom Wedge" || productType == "Custom Utility Iron"){
      var materialType = $('.material-radios input[name="radioMaterial"]:checked').val();
      $(".shaft option").not("[data-material="+materialType+"]").not("[data-material='both']").not(".shaft span option").wrap('<span>');
    } else {
      var materialType = "graphite";
    }
    

    
  } else {
    var shaftBrandFirstModel = $(".shaft option[data-brand='" + shaftBrand + "'][data-flex='"+shaftFlex+"']").first();
    var shaftBrandFirstModelImage = shaftBrandFirstModel.data("img");
      $(".shaft-image").attr('src', shaftBrandFirstModelImage);
  }
      if (shaftBrand != "FreeFlex"){
        $(".shaft option").not("option[data-brand='" + shaftBrand + "'][data-flex='" + shaftFlex + "']").not(".shaft span option").wrap('<span></span>');
        var shaftBrandFirstModel = $(".shaft option[data-brand='" + shaftBrand + "'][data-flex='"+shaftFlex+"'][data-material="+materialType+"]").first().val();
      
        if (flexCount === 0){
          $(".shaft option[data-flex='NA']").unwrap();
          $(".shaft").val(12345678910).change();
        } else {
          $(".shaft").val(shaftBrandFirstModel).change();
        }
        
      } else {
        $(".shaft option").not("option[data-brand='" + shaftBrand + "'][data-material='" + shaftMaterial + "']").not(".shaft span option").wrap('<span></span>');
        var shaftBrandFirstModel = $(".shaft option[data-brand='" + shaftBrand + "']").first().val();
        $(".shaft").val(shaftBrandFirstModel).change();
      }
       
       $(".config").slick("setOption", '', '', true);
  });
  
  
        
}
function changeGripBrand(){
  $("span .grip-model").unwrap();
  var gripBrand = $(".gripBrand").find(':selected').data('brand');
  var gripBrandFirstModel = $(".grip option[data-brand='" + gripBrand + "']").first().val();
     $(".grip").val(gripBrandFirstModel).change();

    $(".grip-model").not("option[data-brand='" + gripBrand + "']").wrap('<span></span>');
       //$(".grip option[data-brand='" + gripBrand + "']").unwrap();

}


    $( document ).ready(function() {
   $(".best-arrow-prev svg").click(function() {
  var leftPos = $('.table-scroll').scrollLeft(); 
    $(".table-scroll").animate({
        scrollLeft: leftPos - 200
    }, 700);
  });
$(".best-arrow-next").click(function() {
  var leftPos = $('.table-scroll').scrollLeft();  
    $(".table-scroll").animate({
        scrollLeft: leftPos + 200
    }, 700);
  });
    });
$(document).ready(function(){
$(".openSpecs").click(function(){
  $(".specsPop, .specsOverlay").css("display","block").animate({opacity:1},200);
});
$(".closeSpecs, .specsOverlay").click(function(){
  $(".specsPop, .specsOverlay").animate({opacity:0}).css("display","none");
});
$('.specsOverlay .specsPop').click(function(e){
   e.stopPropagation();
});
});
function gaAddToCartPush(productArray){
const cartItems = productArray.items;
const cleanedData = [];
const twitterData = [];
var gaValueTotal = 0;
// Loop through each item in the cartItems array
for (let i = 0; i < cartItems.length; i++) {
    const currentItem = cartItems[i];
    gaValueTotal = gaValueTotal + currentItem['final_line_price'];
    // Extract the relevant information
    const cleanedItem = {
        'id': currentItem['id'],
        'name': currentItem['product_title'],
        'brand': currentItem['vendor'],
        'category': currentItem['product_type'],
        'price': currentItem['final_price'] / 100,
        'quantity': currentItem['quantity'],
        'variant': currentItem['variant_title']
    };

  const twitterItem = {
        'content_type': 'Product',
        'content_id': currentItem['id'],
        'content_name': currentItem['product_title'],
        'content_price': currentItem['final_price'] / 100,
        'num_items': currentItem['quantity'],
        'content_group_id': currentItem['id']
    };

    // Add the cleaned item to the array
  if (currentItem['quantity'] > 0){
    cleanedData.push(cleanedItem);
    twitterData.push(twitterItem);
  }
  
}


      gtag('event', 'add_to_cart_custom', {
   'ecomm_prodid':  gaProductId,
    'ecomm_totalvalue': gaValueTotal / 100,
    'ecomm_pagetype': "cart",
    'ecomm_custom_add': "yes",
    'value': gaValueTotal / 100,
    'currency': 'USD',
    'items': cleanedData
});
  
/*
  twq('event', 'tw-ohxif-oj9rr', {
    contents: twitterData, 
    email_address: gaCustomer 
  });
  */
    }



$(".flex").change(function () {
filterShaftOptions(300, false, false); 
});

function changeShaftWithURLParams(){

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const shaftSku = urlParams.get('shaft');
  const shaftmaterial = urlParams.get('material');
  if (shaftSku != "" && shaftSku != null) {
      const shaftVendorParameter = urlParams.get('vendor');
    if (shaftmaterial){
      $('.material-radios label[for="radioGraphite"]').click();
      var timeOut = 700;
      
    } else {
      var timeOut = 25;
    }
    setTimeout(function() {
  
      $('.shaftBrand option[data-brand="'+shaftVendorParameter+'"]').prop('selected', true);
      var shaftBrand = $(".shaftBrand").find(':selected').data('brand');
      $('.shaftBrand').change();
      var handle = $(".shaftBrand").find(':selected').data('handle'); 
           setTimeout(function() {
              var shaftFlex = $(".shaft option[data-sku='" + shaftSku + "']").data("flex");
              $('input[name="flex"][value="'+shaftFlex+'"]').click();
              var shaftID = $(".shaft option[data-sku='" + shaftSku + "']").val();
         
              $(".shaft").val(shaftID).change(); 
              var shaftImage = $('.shaft option[value='+shaftID+']').data('img');
      
              var shaftDesc = $('.shaft option[value='+shaftID+']').data("shaftdesc");
              $(".shaft-image").attr('src', shaftImage);
              $(".shaftDesc").html(shaftDesc);

          }, 800);
    }, timeOut);
      }

    }
